import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux'

import { IntegrationSelector } from '../../selectors';

class LinkDealToSource extends Component {

  render(){

    const {
      integration,
      deal,
    } = this.props;

    if(!integration || deal.source){
      return null;
    }

    return (
      <div className="link-to-source" onClick={this.props.beginLinkingDeal.bind(this)}>Link to Salesforce Deal...</div>
    )
  }
}

const mapStateToProps = state => {
  return {
    integration: IntegrationSelector(state),
  }
}

export default connect(mapStateToProps)(LinkDealToSource);



// WEBPACK FOOTER //
// ./src/components/shared/linkDealToSource.js